import { render, staticRenderFns } from "./LeafLinkLogo.vue?vue&type=template&id=27959dde&"
import script from "./LeafLinkLogo.vue?vue&type=script&lang=js&"
export * from "./LeafLinkLogo.vue?vue&type=script&lang=js&"
import style0 from "./LeafLinkLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports